import * as t from 'io-ts';

export const GiftCategoryDynamicType = t.interface({
    id: t.string,
    name: t.string
});

export type GiftCategory = t.TypeOf<typeof GiftCategoryDynamicType>;
